import React from 'react';
import {useLingui} from "@lingui/react";

function FormattedNumber({value}:{
    value: number
}) {
    const { _, i18n } = useLingui();
    return (
       <span>{i18n.number(value)}</span>
    );
}

export default FormattedNumber;